import * as HTMLElementCreator from '../../../../libs/HTML/HTMLElementCreator';
import type { LevelTask } from '../../../../game/tasks/types';
import { LevelTaskType } from '../../../../game/tasks/types';
import type { EditorInputField } from '../../utils/createEditorInput';
import { createEditorInput } from '../../utils/createEditorInput';

export class EditorGoalsPanelItem {
  public readonly element: HTMLElement;

  private readonly goalSelectBox: HTMLSelectElement;

  private readonly amountInput: HTMLInputElement;

  constructor(
    goal: LevelTask,
    private readonly onGoalModified: () => void,
    private readonly onGoalDeleteRequest: (goalView: EditorGoalsPanelItem) => void,
  ) {
    this.element = HTMLElementCreator.createDiv({
      parentElement: undefined,
      style: {
        padding: '2px 2px 2px 2px',
        color: 'black',
        minWidth: '180px',
        minHeight: '30px',
        backgroundColor: 'rgba(0,0,0,0.5)',
        pointerEvents: 'auto',
        borderColor: 'white',
        borderWidth: '1px',
        borderStyle: 'solid',
        marginTop: '5px',
      },
    });

    this.goalSelectBox = this.createGoalTypeSelector().selectBox;
    this.amountInput = this.createAmountInput().input;
    this.createDeleteButton();

    this.goalSelectBox.value = goal.type;
    this.amountInput.value = goal.amount.toString();
  }

  public destroy(): void {
    this.element.remove();
  }

  private createGoalTypeSelector(): { div: HTMLDivElement; selectBox: HTMLSelectElement } {
    const div = HTMLElementCreator.createDiv({
      parentElement: this.element,
    });

    HTMLElementCreator.createLabel({
      parentElement: div,
      labelText: 'goal type:',
      style: {
        fontSize: '15px',
        color: 'white',
        padding: '5px 5px',
      },
    });

    const selectBox = HTMLElementCreator.createSelectBox({
      parentElement: div,
      onChange: this.onGoalModified,
      style: {
        fontSize: '15px',
      },
      optionsStyle: {
        fontSize: '15px',
      },
      options: [
        { text: 'Hexes', value: LevelTaskType.Hexes },
        { text: 'Plank Blockers', value: LevelTaskType.PlankBlockers },
        { text: 'Tape Blockers', value: LevelTaskType.TapeBlockers },
        { text: 'Knot Blockers', value: LevelTaskType.KnotBlockers },
        { text: 'Birds', value: LevelTaskType.Birds },
        { text: 'Stars', value: LevelTaskType.Stars },
        { text: 'Measure Tape', value: LevelTaskType.MeasureTape },
        { text: 'PlankRed', value: LevelTaskType.PlankRed },
        { text: 'PlankGreen', value: LevelTaskType.PlankGreen },
        { text: 'PlankBlue', value: LevelTaskType.PlankBlue },
        { text: 'PlankPink', value: LevelTaskType.PlankPink },
        { text: 'PlankYellow', value: LevelTaskType.PlankYellow },
        { text: 'PlankGrey', value: LevelTaskType.PlankGrey },
        { text: 'PlankWhite', value: LevelTaskType.PlankWhite },
        { text: 'PlankNavy', value: LevelTaskType.PlankNavy },
        { text: 'PlankPurple', value: LevelTaskType.PlankPurple },
        { text: 'PlankAnyColor', value: LevelTaskType.PlankAny },
      ],
    });

    return { div, selectBox };
  }

  private createAmountInput(): EditorInputField {
    return createEditorInput({
      parentElement: this.element,
      labelText: 'goal amount:',
      restrictRegEx: /^\d+$/,
      initialValue: '0',
      onValueChanged: this.onGoalModified,
      inputStyle: {
        width: '40px',
      },
    });
  }

  private createDeleteButton(): HTMLButtonElement {
    return HTMLElementCreator.createButton({
      parentElement: this.element,
      labelText: 'Remove Goal',
      style: {
        marginTop: '5px',
        color: 'white',
        backgroundColor: 'red',
        fontSize: '13px',
      },
      onClick: () => {
        this.onGoalDeleteRequest(this);
      },
    });
  }

  public export(): LevelTask {
    return {
      type: this.goalSelectBox.value as LevelTaskType,
      amount: parseInt(this.amountInput.value, 10),
    };
  }
}
